import React from 'react'
import { SelectField, SelectFieldProps } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { capitalizeFirstLetter } from 'utils-next/string'

import { CorporateStatus } from '../../../../../../../../../entities-next/corporate'

export type CorporateStatusSelectProps = Omit<SelectFieldProps, 'options' | 'getOptionLabel'>

const corporateStatusOptions = [
  CorporateStatus.inactive,
  CorporateStatus.pov,
  CorporateStatus.active,
  CorporateStatus.trial,
]

function getCorporateStatusLabel(status: CorporateStatus) {
  return capitalizeFirstLetter(status.replace('-', ' '))
}

export function CorporateStatusSelect(selectProps: CorporateStatusSelectProps) {
  return <SelectField options={corporateStatusOptions} getOptionLabel={getCorporateStatusLabel} {...selectProps} />
}
